<div id='div-gpt-ad-1594640818191-0' class="btx-desktop mobile-app-hide header-black"
     style='min-width: 1000px; min-height: 90px;text-align: center;'></div>
<div id='div-gpt-ad-1505377893829-0' class="btx-mobile mobile-app-hide"
    style='min-width: 320px; min-height: 50px;text-align: center;'></div>
<header>

    <!--  -->
    <btx-wide-top-band></btx-wide-top-band>


    <!--  TODO: @Emre bu kısmı da ayrı bir componente alabiliriz.-->
    <!--  LOGO-->
    <div class="bottom-band">
        <div class="container header-wide-container">
            <div class="bottom-band-holder">
                <div class="inside-holder">
                    <!-- Görünürlük SCSS'te; bkz. top-band.component.scss başındaki ngx-layout/SSR notu. -->
                    <!-- href'siz <a> SEO crawlable-anchors'a takılıyor; eylem olduğu için button -->
                    <button type="button" (click)="onToggleSidenav()" class="mobile-menu mobile-app-hide"
                        [attr.aria-label]="'shared.labels.menu' | translate">
                        <img [src]="menuIconPath" alt="Biletix">
                    </button>
                    <btx-site-logo></btx-site-logo>
                </div>
                
                <!--        -->
                <btx-wide-event-category-menu></btx-wide-event-category-menu>

                <!-- Bölge çipi: yalnızca mobil uygulama modunda ve anasayfada görünür; logo ile ikonların ortasında -->
                <btx-wide-region-selector *ngIf="isHomepage()"></btx-wide-region-selector>

                <!--        -->
                <btx-wide-event-search-box></btx-wide-event-search-box>

                <!--        -->
                <div class="bottom-band-inside-holder" fxLayout="row">

                    <!-- Account Menu         -->
                    <btx-wide-account-dropdown></btx-wide-account-dropdown>

                    <!-- App'te sepet sayacı native tab bar'da; header'daki gizli (DOM'da kalır, mobil senkron okur) -->
                    <btx-header-countdown-timer *ngIf="showTimerInHeader()" class="mobile-app-hide"></btx-header-countdown-timer>
                    <!-- <btx-countdown-timer></btx-countdown-timer> -->

                    <!--          -->
                    <btx-wide-cart-dropdown class="mobile-app-hide"></btx-wide-cart-dropdown>


                </div>

            </div>
            <div class="category-filter-bar" *ngIf="isHomepage()">
                <div class="category-filter">
                    <!-- Şehir (Location) -->
                    <div class="select-holder location">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                d="M2.63817 10.0983L7.48757 12.1766L7.82337 12.5124L9.90168 17.3618L17.1652 2.83479L2.63817 10.0983ZM0.833344 9.57109L18.3089 0.833313L19.1667 1.69109L10.4289 19.1666L9.26939 19.1326L6.7488 13.2512L0.867417 10.7306L0.833344 9.57109Z"
                                fill="#024DDF" />
                        </svg>
                        <mat-form-field appearance="outline" class="no-style-field">
                            <mat-select [(value)]="selectedCity" [panelClass]="'filter-bottom-sheet'">
                                <mat-select-trigger>
                                    {{ selectedCity === '-1' ? ('home.labels.allCities' | translate) : selectedCity }}
                                </mat-select-trigger>
                                <mat-option value="-1">{{ 'home.labels.allCities' | translate }}</mat-option>
                                <mat-option *ngFor="let city of cities" [value]="city.name">{{ city.name }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <!-- Tüm Tarihler (Date) -->
                    <div class="select-holder date">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <g clip-path="url(#clip0_4952_9677)">
                                <path
                                    d="M7.29199 2.5H12.708V0.833008H13.958V2.5H19.167V15.0898L15.0244 19.167H0.833008V2.5H6.04199V0.833008H7.29199V2.5ZM2.08301 17.917H14.0293V14.0293H17.917V7.70801H2.08301V17.917ZM15.1377 15.1377V17.3008L17.3359 15.1377H15.1377ZM8.125 13.958H3.54199V9.375H8.125V13.958ZM4.79199 12.708H6.875V10.625H4.79199V12.708ZM2.08301 6.45801H17.917V3.75H13.958V5.41699H12.708V3.75H7.29199V5.41699H6.04199V3.75H2.08301V6.45801Z"
                                    fill="#024DDF" />
                            </g>
                            <defs>
                                <clipPath id="clip0_4952_9677">
                                    <rect width="20" height="20" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        <mat-form-field appearance="outline">
                            <mat-select [(value)]="selectedDate" (selectionChange)="onDateChange($event)"
                                [panelClass]="'filter-bottom-sheet'">
                                <mat-select-trigger>
                                    {{ isCustomRange() ? getFormattedRange() : (getDateLabel(selectedDate) | translate)
                                    }}
                                </mat-select-trigger>
                                <mat-option value="-1">{{ 'home.labels.allDates' | translate }}</mat-option>
                                <mat-option id="seldatarange" value="daterange">{{ 'home.labels.dateRange' | translate
                                    }}</mat-option>
                                <mat-option value="today">{{ 'home.labels.today' | translate }}</mat-option>
                                <mat-option value="weekend">{{ 'home.labels.weekend' | translate }}</mat-option>
                                <mat-option value="nextweekend">{{ 'home.labels.nextWeekend' | translate }}</mat-option>
                                <mat-option value="thisweek">{{ 'home.labels.thisWeek' | translate }}</mat-option>
                                <mat-option value="next14days">{{ 'home.labels.next14Days' | translate }}</mat-option>
                                <mat-option value="next30days">{{ 'home.labels.next30Days' | translate }}</mat-option>

                            </mat-select>
                        </mat-form-field>
                    </div>

                    <!-- Kategori (Category) -->
                    <div class="select-holder categorie">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <g clip-path="url(#clip0_6176_5974)">
                                <path
                                    d="M9.16699 19.167H0.833008V10.833H9.16699V19.167ZM19.167 15L15 19.167H10.833V10.833H19.167V15ZM2.08301 17.917H7.91699V12.083H2.08301V17.917ZM12.083 17.917H14.4824L17.917 14.4824V12.083H12.083V17.917ZM9.16699 9.16699H0.833008V0.833008H9.16699V9.16699ZM19.167 9.16699H10.833V0.833008H19.167V9.16699ZM2.08301 7.91699H7.91699V2.08301H2.08301V7.91699ZM12.083 7.91699H17.917V2.08301H12.083V7.91699Z"
                                    fill="#024DDF" />
                            </g>
                            <defs>
                                <clipPath id="clip0_6176_5974">
                                    <rect width="20" height="20" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        <mat-form-field appearance="outline" class="small-field">
                            <mat-select [(value)]="selectedCategory" [panelClass]="'filter-bottom-sheet'">
                                <mat-select-trigger>
                                    {{ getCategoryLabel(selectedCategory) | translate }}
                                </mat-select-trigger>
                                <mat-option value="-1">{{ 'home.labels.allCategories' | translate }}</mat-option>
                                <mat-option value="MUSIC">{{ 'home.labels.categoryMusic' | translate }}</mat-option>
                                <mat-option value="SPORT">{{ 'home.labels.categorySport' | translate }}</mat-option>
                                <mat-option value="ART">{{ 'home.labels.categoryArt' | translate }}</mat-option>
                                <mat-option value="FAMILY">{{ 'home.labels.categoryFamily' | translate }}</mat-option>
                                <mat-option value="OTHER">{{ 'home.labels.categoryOther' | translate }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <button class="discover-btn" (click)="discover()">{{ 'home.labels.discover' | translate }}</button>
                </div>

            </div>

        </div>
    </div>
</header>
